import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';
import { logger } from '@/helpers/log.service';
import { DocumentAddReturnParameters } from '@/services/document.models';

export const documentService = {
  documentsGet,
  documentAdd,
  documentImport,
  documentImportFindUsers,
  documentEdit,
  changeOptionHideUsersPersonalInfo,
  documentEditProcessed,
  documentDel,
  documentDataGet,
  documentsView,
  documentsViewByCode,
  documentFilesGet,
  documentFilesAdd,
  documentFileSignaturesAdd,
  documentFilesDel,
  documentActionHistGet,
  documentActionHistDetailsGet,
  documentActionHistUsersGet,
  documentsDownloadFile,
  documentsDownloadFileWithSigns,
  documentsDownloadDocument,
  documentsDownloadDocumentList,
  checkSyncedDownloadDocumentListAllowed,
  documentsFind,
  documentsFavoritesChange,
  documentsArchiveChange,
  documentRestore,
  documentDestroy,
  documentCopy,
  documentCreateNewFrom,
  summary,
  documentsSummaryDocuments,
  summaryDocumentsHistory,
  sendDocuments,
  heart,
  documentProcessChange,
  downloadPdf,
  documentFilesParametersChange,
  organisationsGet,
  notSyncedFilesGet,
  syncFiles,
  notSyncedFileSignCountGet,
  refusePayDelivery,
  activeAccessToDocumentByUrl,
  deactiveAccessToDocumentByUrl,
  validateDocumentAccessToken,
  changeIncomingParams,
  getDocumentShablonConfig,
  updateDocumentShablonValues
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'documents'
};

function extract(r) {
  return r.data;
}

async function documentActionHistGet(
  documentVersionCode: string,
  totalCountRequired: boolean,
  pageSize: number,
  pageNum: number,
  historyTypeFilter: Array<number> | null = null,
  userFilter: Array<string> | null = null,
  unregUserFilter: Array<string> | null = null,
  dateBeginFilter: string | null = null,
  dateEndFilter: string | null = null) {
  return axios
    .post(
      `${model.baseUrl}${model.controller}/ActionHistGet`,
      {
        documentVersionCode,
        totalCountRequired,
        pageSize,
        pageNum,
        historyTypeFilter,
        userFilter,
        unregUserFilter,
        dateBeginFilter,
        dateEndFilter
      }
    )
    .then(extract);
}

async function documentActionHistDetailsGet(documentsActionHistoryId: number) {
  return axios
    .get(`${model.baseUrl}${model.controller}/ActionHistDetailGet?documentsActionHistoryId=${documentsActionHistoryId}`)
    .then(extract);
}

async function documentActionHistUsersGet(documentVersionCode: string) {
  return axios
    .get(`${model.baseUrl}${model.controller}/ActionHistUsersGet?documentVersionCode=${documentVersionCode}`)
    .then(extract);
}

async function documentFilesGet(pDocumentVersionCode, documentAccessToken: string = '') {
  return axios.post(`${model.baseUrl}${model.controller}/FilesGet`, { pDocumentVersionCode, documentAccessToken }).then(extract);
}

async function documentDataGet(pDocumentVersionCode, pConfirmRecepientPayDocument, documentAccessToken: string = '') {
  return axios
    .post(`${model.baseUrl}${model.controller}/DataGet`,
      { pDocumentVersionCode, pConfirmRecepientPayDocument, documentAccessToken })
    .then(extract);
}

async function documentsView(pDocumentVersionsFileCode) {
  return axios.post(`${model.baseUrl}${model.controller}/View`, { pDocumentVersionsFileCode });
}

async function documentsViewByCode(documentVersionCode: string) {
  if (documentVersionCode == null) {
    documentVersionCode = '';
  }
  return axios.get(`${model.baseUrl}${model.controller}/ViewByCode?documentVersionCode=${documentVersionCode}`);
}

async function documentsDownloadFile(pDocumentVersionsFileCode) {
  return axios.get(`${model.baseUrl}${model.controller}/downloadFile?documentVersionsFileCode=${pDocumentVersionsFileCode}`);
}

async function documentsDownloadFileWithSigns(documentVersionCode: string, documentVersionsFileCode: string) {
  let url = `${model.baseUrl}${model.controller}/downloadFileWithSigns`;
  url += `?documentVersionCode=${documentVersionCode || ''}`;
  url += `&documentVersionsFileCode=${documentVersionsFileCode || ''}`;
  return axios.get(url, { responseType: 'blob' });
}

async function documentsDownloadDocument(documentVersionsode, actionsReport: boolean = false) {
  return axios.get(`${model.baseUrl}${model.controller}/downloadDocument?documentVersionCode=${documentVersionsode}&actionsReport=${actionsReport}`,
    { responseType: 'blob' });
}

async function documentsDownloadDocumentList(documentVersionCodes: Array<string>, withActionsReport: boolean = false) {
  return axios.post(`${model.baseUrl}${model.controller}/DownloadDocumentList`, { documentVersionCodes, withActionsReport },
    { responseType: 'blob' });
}

async function checkSyncedDownloadDocumentListAllowed(documentVersionCodes: Array<string>) {
  return axios
    .post(`${model.baseUrl}${model.controller}/CheckSyncedDownloadDocumentListAllowed`, { documentVersionCodes })
    .then(extract);
}

async function downloadPdf(documentVersionFileCode, documentAccessToken: string = '') {
  return axios
    .get(`${model.baseUrl}${model.controller}/DownloadPdfBytes?documentVersionFileCode=${documentVersionFileCode}&documentAccessToken=${documentAccessToken}`,
      { responseType: 'blob' });
}

async function documentsGet(
  pageNum,
  moduleType,
  folderId,
  fs,
  fdocname,
  fdocdescr,
  fdlogin,
  fdfirstname,
  fdlastname,
  fdphonenum,
  fdorgname,
  fdorgdep,
  sdate,
  edate,
  fdocnumber,
  sdocdate,
  edocdate,
  fileFolderType,
  fileFolder,
  isOrgDoc,
  myOrganizationCode,
  maxRecomendedGridSize,
  periodType,
  year,
  quarter,
  month,
  fdocincnum,
  sdocincdate,
  edocincdate
) {
  try {
    const response = await axios.post(
      model.baseUrl + 'Documents/Get',
      JSON.stringify({
        pageNum,
        moduleType,
        folderId,
        fs,
        fdocname,
        fdocdescr,
        fdlogin,
        fdfirstname,
        fdlastname,
        fdphonenum,
        fdorgname,
        fdorgdep,
        sdate,
        edate,
        fdocnumber,
        sdocdate,
        edocdate,
        fileFolderType,
        fileFolder,
        isOrgDoc,
        myOrganizationCode,
        maxRecomendedGridSize,
        periodType,
        year,
        quarter,
        month,
        fdocincnum,
        sdocincdate,
        edocincdate
      }),
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return response;
  } catch (e) {
    return Promise.reject(e);
  }
}

async function documentsFind(documentName, dateBegin, dateEnd, docType) {
  return axios.post(model.baseUrl + 'Documents/Find', { documentName, dateBegin, dateEnd, docType }).then(extract);
}

async function documentDel(pDocumentVersionCodes, ignoreNotHandledActions) {
  return axios.post(model.baseUrl + 'Documents/Del', { pDocumentVersionCodes, ignoreNotHandledActions });
}

async function documentDestroy(pDocumentVersionCodes) {
  return axios.post(model.baseUrl + 'Documents/Destroy', { pDocumentVersionCodes });
}

async function documentRestore(pDocumentVersionCodes) {
  return axios.post(model.baseUrl + 'Documents/Restore', { pDocumentVersionCodes });
}

async function documentEdit(documentVersionCode, documentName, documentNumber, documentDate, documentDescription, departmentId,
  documentTypeId) {
  return axios
    .post(model.baseUrl + 'Documents/Edit',
      { documentVersionCode, documentName, documentNumber, documentDate, documentDescription, departmentId, documentTypeId }
    );
}

function changeOptionHideUsersPersonalInfo(documentVersionCode: string, hideUsersPersonalInfo: boolean) {
  return axios.post(model.baseUrl + 'Documents/ChangeOptionHideUsersPersonalInfo', { documentVersionCode, hideUsersPersonalInfo });
}

async function documentEditProcessed(pDocumentVersionCode, departmentId) {
  return axios.post(model.baseUrl + 'Documents/EditProcessed', {
    pDocumentVersionCode,
    departmentId
  });
}

async function documentAdd(
  documentName: string,
  documentNumber: string,
  documentDate: Date,
  documentDescription: string,
  files: [],
  userFolderId: number,
  isOrganizationDocument: boolean,
  departmentId: number,
  myOrganisationCode: string,
  users: [],
  relatedDocumentVersionCodes: null,
  // eslint-disable-next-line camelcase
  shablonDocumentConfig_Id: number,
  shablonDocumentGUID: string,
  shablonValuesJson: string,
  isBlank: number,
  blankId: number,
  hideUsersPersonalInfo: boolean,
  documentTypeId: number,
  educationDocRegistryUid: string = ''
): Promise<DocumentAddReturnParameters> {
  let { data } = await axios.post<DocumentAddReturnParameters>(`${model.baseUrl}${model.controller}/Add`, {
    name: documentName,
    number: documentNumber,
    date: documentDate,
    description: documentDescription,
    files: files,
    userFolderId: userFolderId,
    isOrganizationDocument: isOrganizationDocument,
    departmentId: departmentId,
    myOrganisationCode: myOrganisationCode,
    users: users,
    relatedDocumentVersionCodes,
    shablonDocumentConfig_Id,
    shablonDocumentGUID,
    shablonValuesJson,
    isBlank,
    blankId,
    hideUsersPersonalInfo,
    documentTypeId,
    educationDocRegistryUid
  });

  return data;
}

function documentImport(
  name: string,
  number: string,
  date: Date | string | null,
  files: Array<any>,
  users: Array<any>,
  isOrganizationDocument: boolean,
  myOrganisationCode: string,
  departmentId: number,
  onProgress
) {
  const CancelToken = axios.CancelToken;
  let cancel;
  let request = axios.post(`${model.baseUrl}${model.controller}/Import`,
    { name, number, date, files, users, isOrganizationDocument, myOrganisationCode, departmentId },
    {
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
      onUploadProgress: function(progressEvent) {
        let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress(percentCompleted);
      }
    }).catch(function(err) {
    if (axios.isCancel(err)) {
      logger.debug(err.message);
    } else {
      throw err;
    }
  });
  return { request, cancel };
}

async function documentImportFindUsers(users: []) {
  return axios.post(`${model.baseUrl}${model.controller}/FindImportUsers`, { users }).then(extract);
}

async function documentFilesAdd(documentVersionCode: string, files: []) {
  return axios.post(model.baseUrl + 'Documents/FilesAdd', { files, documentVersionCode });
}

async function documentFileSignaturesAdd(
  documentVersionCode: string,
  documentVersionsFileCode: string,
  signatures: any[],
  replaceBySerialConfirmed: boolean = false) {
  return axios
    .post(
      model.baseUrl + 'Documents/FileSignaturesAdd',
      { documentVersionCode, documentVersionsFileCode, signatures, replaceBySerialConfirmed }
    )
    .then(extract);
}

async function documentFilesDel(fileCodes: []) {
  try {
    const response = await axios.post(
      model.baseUrl + 'Documents/FilesDel',
      JSON.stringify({
        fileCodes
      }),
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return response;
  } catch (e) {
    return Promise.reject(e);
  }
}

async function documentsFavoritesChange(pDocumentCodes, pIsFavorites) {
  return axios.post(model.baseUrl + 'Documents/FavoritesChanege', { pDocumentCodes, pIsFavorites });
}

async function documentsArchiveChange(pDocumentCodes, pIsArchive) {
  return axios.post(model.baseUrl + 'Documents/ArchiveChange', { pDocumentCodes, pIsArchive });
}

async function documentCopy(documentCode: string, isOrganizationDocument: number) {
  return axios.post(`${model.baseUrl}${model.controller}/copy`, { documentCode, isOrganizationDocument });
}

async function documentCreateNewFrom(documentVersionCode: string, isOrganizationDocument: number) {
  return axios.post(`${model.baseUrl}${model.controller}/createfrom`, { documentVersionCode, isOrganizationDocument });
}

async function summary(isOrgDocs: boolean, myOrganizationCode: string = '') {
  return axios
    .get(`${model.baseUrl}${model.controller}/summaryget?isOrgDocs=${isOrgDocs}&myOrganizationCode=${myOrganizationCode || ''}`)
    .then(extract);
}

async function documentsSummaryDocuments(count: number, myOrganizationCode: string = '') {
  return axios
    .get(`${model.baseUrl}${model.controller}/documentssummarydocumentsget?number=${count}&myOrganizationCode=${myOrganizationCode || ''}`)
    .then(extract);
}

async function summaryDocumentsHistory(count: number, myOrganizationCode: string = '') {
  return axios
    .get(`${model.baseUrl}${model.controller}/summarydocumentshistoryget?number=${count}&myOrganizationCode=${myOrganizationCode || ''}`)
    .then(extract);
}

async function sendDocuments(documentVersionCodes: string[]) {
  return axios.patch(`${model.baseUrl}${model.controller}/SendDocuments`, documentVersionCodes);
}

async function heart() {
  return axios.get(`${model.baseUrl}${model.controller}/heart`);
}

async function documentProcessChange(docVersionCode) {
  return axios.post(model.baseUrl + 'Documents/ProcessChange', { docVersionCode });
}

async function documentFilesParametersChange(documentVersionsFileCode, isCoverLetter, isMainDocumentFile) {
  return axios.post(model.baseUrl + 'Documents/DocumentFilesParametersChange', {
    documentVersionsFileCode,
    isCoverLetter,
    isMainDocumentFile
  });
}

async function organisationsGet(documentVersionCode) {
  return axios.get(`${model.baseUrl}${model.controller}/organisationsGet?documentVersionCode=${documentVersionCode}`);
}

async function notSyncedFilesGet(documentVersionCode) {
  return axios
    .get(`${model.baseUrl}${model.controller}/NotSyncedFilesGet?documentVersionCode=${documentVersionCode}`)
    .then(extract);
}

async function syncFiles(documentVersionCode: string, documentVersionFileCodes: string[]) {
  return axios
    .post(`${model.baseUrl}${model.controller}/SyncFiles`, { documentVersionCode, documentVersionFileCodes });
}

async function notSyncedFileSignCountGet(documentVersionCode) {
  return axios
    .get(`${model.baseUrl}${model.controller}/NotSyncedFileSignCountGet?documentVersionCode=${documentVersionCode}`)
    .then(extract);
}

async function refusePayDelivery(documentVersionCode) {
  return axios
    .post(`${model.baseUrl}${model.controller}/RefusePayDelivery`, { documentVersionCode })
    .then(extract);
}

function activeAccessToDocumentByUrl(documentVersionCode) {
  return axios
    .post(`${model.baseUrl}${model.controller}/ActivateAccessByUrl`, { documentVersionCode })
    .then(extract);
}

function deactiveAccessToDocumentByUrl(documentVersionCode) {
  return axios
    .post(`${model.baseUrl}${model.controller}/DeactivateAccessByUrl`, { documentVersionCode })
    .then(extract);
}

function validateDocumentAccessToken(documentAccessToken: string) {
  return axios
    .get(`${model.baseUrl}${model.controller}/ValidateDocumentAccessToken?documentAccessToken=${documentAccessToken}`)
    .then(extract);
}

function changeIncomingParams(documentVersionCode: string, documentIncomingNumber: string, documentIncomingDate: string): Promise<boolean> {
  return axios
    .post(`${model.baseUrl}${model.controller}/ChangeIncomingParams`,
      { documentVersionCode, documentIncomingNumber, documentIncomingDate })
    .then(extract);
}

async function getDocumentShablonConfig(documentVersionCode: string): Promise<any> {
  let { data } = await axios.get<any>(`${model.baseUrl}${model.controller}/GetDocumentShablonConfig/${documentVersionCode}`);

  return data;
}

async function updateDocumentShablonValues(documentVersionCode: string, shablonValuesJson: string): Promise<boolean> {
  let { data } = await axios.post<boolean>(
    `${model.baseUrl}${model.controller}/UpdateDocumentShablonValues`,
    { documentVersionCode, shablonValuesJson });

  return data;
}
